import { FunctionComponent, DragEvent } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCommentSms, faEnvelope, faClock, faSplit, faGripDotsVertical } from '@fortawesome/pro-regular-svg-icons';
import { InsertableType } from '../../Canvas/useAutomationFlow';
import { useFlowContext } from '../FlowContext';
import styles from './ToolboxSidebar.module.scss';

interface ToolboxItem {
    type: InsertableType;
    label: string;
    icon: typeof faClock;
}

const ACTIONS: ToolboxItem[] = [
    { type: 'email', label: 'Send Email', icon: faEnvelope },
    { type: 'sms', label: 'Send SMS', icon: faCommentSms }
];

const RULES: ToolboxItem[] = [
    { type: 'delay', label: 'Time Delay', icon: faClock },
    { type: 'split', label: 'Split If/No', icon: faSplit }
];

const ToolboxSidebar: FunctionComponent = () => {
    const { setDraggingType } = useFlowContext();

    const handleDragStart = (e: DragEvent<HTMLDivElement>, type: InsertableType) => {
        e.dataTransfer.setData('automation/node-type', type);
        e.dataTransfer.effectAllowed = 'copy';
        setDraggingType(type);
    };

    const handleDragEnd = () => {
        setDraggingType(null);
    };

    const renderItem = (item: ToolboxItem) => (
        <div
            key={item.type}
            className={styles.item}
            draggable
            onDragStart={e => handleDragStart(e, item.type)}
            onDragEnd={handleDragEnd}
        >
            <div className={styles.itemLeft}>
                {item.type === 'split' ? (
                    <div className={styles.itemIconDiamond}>
                        <FontAwesomeIcon
                            icon={item.icon}
                            className={styles.itemIconInner}
                        />
                    </div>
                ) : (
                    <div className={`${styles.itemIcon} ${styles[`itemIcon_${item.type}`]}`}>
                        <FontAwesomeIcon icon={item.icon} />
                    </div>
                )}
                <span className={styles.itemLabel}>{item.label}</span>
            </div>
            <FontAwesomeIcon
                icon={faGripDotsVertical}
                className={styles.dragHandle}
            />
        </div>
    );

    return (
        <aside className={styles.sidebar}>
            <div className={styles.section}>
                <span className={styles.sectionTitle}>Actions</span>
                {ACTIONS.map(renderItem)}
            </div>
            <div className={styles.section}>
                <span className={styles.sectionTitle}>Rules</span>
                {RULES.map(renderItem)}
            </div>
        </aside>
    );
};

export default ToolboxSidebar;
